<template>
    <div>
        <v-combobox v-bind="$attrs" v-model="model"
            :items="users" 
            item-value="id"
            item-text="full_name"
            :search-input.sync="search"
            hide-details
            :placeholder="childplaceholder" 
            :clearable="clearable"
            @click:clear="() => {
                $emit('input', '')
                $emit('set_value', '')
            }"
            class="form-control form-control-sm" :class="childclass">
            <template v-slot:no-data>
                <v-list-item>
                    {{ loading == 'search' ? 'Buscando...' : 'No hay datos disponibles'}}
                </v-list-item>
            </template>
        </v-combobox>
    </div>
</template>
<script>
export default {
    props: {
        childplaceholder: '',
        childclass: '',
        clearable: false,
        role: ''
    },
    data(){
        return{
            loading: '',
            search: '',
            users: [],
            key_up: 0,
        }
    },
    computed: {
        model: {
            get() { 
                return this.$attrs.value
            },
            set(val) {
                this.$emit('input', val)
                if(val){
                    this.$emit('set_value', val.id)
                }
            }
        }
    },
    methods: {
        USERS: function () {
            let vue = this
            axios({
                url: '/search/users?query=' + vue.search + ( vue.role ? '&role=' + vue.role : ''),
                method: 'GET'
            })
                .then((resp) => {
                    vue.users = resp.data
                })
                .catch((err) => {
                    if (err.response.status === 402 || err.response.status === 404) {
                       let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    } else {
                        vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }
                })
                .finally((resp) => {
                    vue.loading = ''
                })
        },
    },
    watch: {
        search: {
            handler(value) {
                let vue = this
                vue.$emit('input', value)
                vue.loading = 'search'
                if(!value){
                    vue.key_up = 0
                    vue.users = []
                    vue.loading = ''
                    return
                }
                vue.key_up = value.length
                setTimeout(() => {
                    if(vue.key_up == value.length){
                        vue.USERS()
                        vue.key_up = 0
                    }
                }, 500)
            }
        }
    }
}
</script>